import qs from 'query-string';
import {
  SERVER_AUTH_URL,
  SERVER_DISCOUNTS_URL,
  SERVER_MENU_SYNC_URL,
  SERVER_TEST_AUTO_URL,
  SERVER_UBEREATS_URL,
  SERVER_URL,
  SERVER_URL_BOOK_A_DRIVER,
  REPORTS_SERVICE_URL,
  CORE_ORDERS_SERVICE_URL,
  HUBSPOT_URL,
  HUBSPOT_SERVICE_URL,
  SERVER_MARKETING_SERVICE_URL,
  REFUND_CALCULATOR_URL,
  INSIGHTS_SERVICE_URL,
  PAYMENT_ADJUSTMENTS_SERVICE_URL,
  CONFIGURATION_SERVICE_URL,
  RDB_SERVICE_V2_URL,
  SERVER_DISCOUNTS_V2_URL,
  MENU_SERVICE_URL,
  ORDER_MANAGEMENT_SERVICE_URL,
  FEEDBACK_SURVEY_SERVICE_URL,
  MERCHANT_DASHBOARD_API_URL
} from 'helpers/services/constants/API_CONSTANTS';

export const GET_ALL_REVIEWS = ({page, limit, sort, sortBy}) =>
  `${SERVER_URL}/reviews?page=${page}&limit=${limit}&sort=${sort}&sortBy=${sortBy}`;

export const GET_REVIEW_BY_ID = (id) => `${SERVER_URL}/reviews/${id}`;

export const REPLIES = (id) => `${SERVER_URL}/reviews/${id}/reply`;

export const REPLIED_REVIEWS_BY_USER = (reviewId, userId) =>
  `${SERVER_URL}/reviews/${reviewId}/replies/${userId}`;

// Menu-editor API endpoints

export const UPDATE_SORTING_ORDER = () => `${SERVER_URL}/updateSortingOrder`;

export const MENU_EDITOR_OVERVIEW = ({
  page,
  limit,
  sort,
  sortBy,
  deepLevel = 7
}) =>
  `${SERVER_URL}/overviews?page=${page}&limit=${limit}&sort=${sort}&sortBy=${sortBy}&deepLevel=${deepLevel}`;

export const MENU_EDITOR_OVERVIEW_UNAVAILABLE = ({
  page,
  limit,
  sort,
  sortBy,
  deepLevel = 7
}) =>
  `${SERVER_URL}/sections/invisible?page=${page}&limit=${limit}&sort=${sort}&sortBy=${sortBy}&deepLevel=${deepLevel}`;

export const GET_MENU_EDITOR_OVERVIEW_BY_ID = (id) =>
  `${SERVER_URL}/sections/${id}`;

export const POST_MENU_EDITOR_OVERVIEW = () => `${SERVER_URL}/sections`;

export const UPDATE_MENU_EDITOR_OVERVIEW = (id) =>
  `${SERVER_URL}/sections/${id}`;

export const PATCH_MENU_EDITOR_SECTION = (id) => `${SERVER_URL}/sections/${id}`;

export const DELETE_MENU_EDITOR_OVERVIEW = (id) =>
  `${SERVER_URL}/sections/${id}`;

export const GET_MENU_EDITOR_ITEMS = ({
  page,
  limit,
  sort,
  sortBy,
  outStock,
  deepLevel = 5
}) =>
  `${SERVER_URL}/menu-items?page=${page}&limit=${limit}&sort=${sort}&sortBy=${sortBy}&outStock=${outStock}&deepLevel=${deepLevel}`;

export const GET_MENU_EDITOR_ITEMS_UNAVAILABLE = ({
  page,
  limit,
  sort,
  sortBy,
  outStock,
  deepLevel = 5
}) =>
  `${SERVER_URL}/menu-items/invisible?page=${page}&limit=${limit}&sort=${sort}&sortBy=${sortBy}&outStock=${outStock}&deepLevel=${deepLevel}`;

export const GET_MENU_EDITOR_ITEM_BY_ID = (id) =>
  `${SERVER_URL}/menu-items/${id}`;

export const POST_MENU_EDITOR_ITEMS = () => `${SERVER_URL}/menu-items`;

export const UPDATE_MENU_EDITOR_ITEM = (id) => `${SERVER_URL}/menu-items/${id}`;

export const DELETE_MENU_EDITOR_ITEM = (id) => `${SERVER_URL}/menu-items/${id}`;

export const PATCH_MENU_EDITOR_ITEM = (id) => `${SERVER_URL}/menu-items/${id}`;

export const GET_MENU_EDITOR_MODIFIERS = ({page, limit, sort, sortBy}) =>
  `${SERVER_URL}/m-groups?page=${page}&limit=${limit}&sort=${sort}&sortBy=${sortBy}&deepLevel=8`;

export const GET_MENU_EDITOR_OUT_STOCK = () => `${SERVER_URL}/out-in-stocks`;

export const GET_MENU_EDITOR_ALL_MODIFIERS = ({
  page,
  limit,
  sort,
  sortBy,
  outStock,
  deepLevel = 5
}) =>
  `${SERVER_URL}/modifiers?fields=standart&search=EGV&page=${page}&limit=${limit}&sort=${sort}&sortBy=${sortBy}&outStock=${outStock}&deepLevel=${deepLevel}`;
export const GET_MENU_EDITOR_MODIFIERS_UNAVAILABLE = ({
  page,
  limit,
  sort,
  sortBy
}) =>
  `${SERVER_URL}/modifiers/invisible?page=${page}&limit=${limit}&sort=${sort}&sortBy=${sortBy}&deepLevel=8`;
// Single modifier

export const GET_MENU_EDITOR_MODIFIER_BY_ID = (id) =>
  `${SERVER_URL}/modifiers/${id}`;

export const PATCH_MENU_EDITOR_MODIFIER = (id) =>
  `${SERVER_URL}/modifiers/${id}`;
export const POST_MENU_EDITOR_MODIFIER = () => `${SERVER_URL}/modifiers`;
export const UPDATE_MENU_EDITOR_MODIFIER = (id) =>
  `${SERVER_URL}/modifiers/${id}`;
export const DELETE_MENU_EDITOR_MODIFIER = (id) =>
  `${SERVER_URL}/modifiers/${id}`;

// Modifier groups
export const GET_MENU_EDITOR_MODIFIER_GROUP_BY_ID = (id) =>
  `${SERVER_URL}/m-groups/${id}`;

export const POST_MENU_EDITOR_MODIFIER_GROUPS = () => `${SERVER_URL}/m-groups`;
export const UPDATE_MENU_EDITOR_MODIFIER_GROUPS = (id) =>
  `${SERVER_URL}/m-groups/${id}`;
export const DELETE_MENU_EDITOR_MODIFIER_GROUPS = (id) =>
  `${SERVER_URL}/m-groups/${id}`;

// User locations API endpoints
export const USER_LOCATIONS_DATA = () => `${SERVER_URL}/locations`;
export const USER_DATA = () => `${SERVER_URL}/users/current`;
export const UPDATE_USER = (userId) => `${SERVER_URL}/users/${userId}`;
export const PATCH_USER = (userId) => `${SERVER_URL}/users/${userId}`;
export const GET_USER_STATISTIC = ({userId, tag, role, sourceType}) =>
  `${SERVER_URL}/app/user-statistic/${userId}?tag=${tag}&role=${role}&sourceType=${sourceType}`;
export const POST_USER_STATISTIC = () => `${SERVER_URL}/app/user-statistic`;
export const SET_BYOC_CONFIGURATION_STATUS = (locationId, status) =>
  `${SERVER_URL}/location/${locationId}/byoc/${status}`;

export const LOCATION_DATA = (id) => `${SERVER_URL}/locations-management/${id}`;
export const LOCATION_SETUP_DATA = (id) =>
  `${SERVER_URL}/locations-management/${id}/setup-data`;
export const LOCATION_NOTIFICATIONS = (locationId, userId) =>
  `${SERVER_URL}/locations-management/${locationId}/${userId}/notifications`;
export const LOCATION_CLOUD_PRINT = (locationId) =>
  `${SERVER_URL}/locations-management/${locationId}/cloud-print`;
export const PATCH_LOCATION = (locationId, id) =>
  `${SERVER_URL}/locations-management/${locationId}/${id}`;
export const UPDATE_SERVICE_FEATURE = (feature, status) =>
  `${SERVER_URL}/locations-management/service-features?feature=${feature}&status=${status}`;
export const UPDATE_SERVICE_FEATURE_AVAILABILITY = (feature, status) =>
  `${SERVER_URL}/locations-management/service-features/availability?feature=${feature}&isNewFeature=${status}`;
export const UPDATE_SERVICE_FEATURE_ADVANCED = (feature, isAdvanced) =>
  `${SERVER_URL}/locations-management/service-features/advanced?feature=${feature}&IsAdvanced=${isAdvanced}`;
export const CREATE_FEATURE = () =>
  `${SERVER_URL}/locations-management/service-features`;
export const UPDATE_FEATURE = (feature) =>
  `${SERVER_URL}/locations-management/service-features?feature=${feature}`;
export const DELETE_FEATURE = (feature) =>
  `${SERVER_URL}/locations-management/service-features?feature=${feature}`;

export const POST_FILES = () => `${SERVER_URL}/files`;
export const DELETE_FILE = (file) => `${SERVER_URL}/files/${file}`;

export const GET_MENU_EDITOR_SECTION_TREE = (id) =>
  `${SERVER_URL}/section-tree/${id}`;
export const GET_MENU_EDITOR_ITEM_TREE = (id) =>
  `${SERVER_URL}/menu-item-tree/${id}`;
export const GET_MENU_EDITOR_MODIFIER_GROUP_TREE = (id) =>
  `${SERVER_URL}/m-group-tree/${id}`;
export const GET_MENU_EDITOR_MODIFIER_TREE = (id) =>
  `${SERVER_URL}/modifier-tree/${id}`;
export const GET_MENU_EDITOR_OUT_OFF_STOCK_COUNTERS = () =>
  `${SERVER_URL}/out-off-stocks/count`;
export const GET_MENU_EDITOR_HIDDEN_COUNTERS = () =>
  `${SERVER_URL}/invisible/count`;

// Merchant API endpoints
export const UPDATE_MERCHANT = (id) => `${SERVER_URL}/merchants/${id}`;

// User account setup API endpoints
export const SETUP_ACCOUNT = (lastStep) =>
  `${SERVER_URL}/account?lastStep=${lastStep}`;
export const GET_SETUP_ACCOUNT = (userId) => `${SERVER_URL}/account/${userId}`;

export const POST_STEP_ACCOUNT = (lastStep) =>
  `${SERVER_URL}/signUp2/account?lastStep=${lastStep}`;
export const GET_STEPS_ACCOUNT = (userId) =>
  `${SERVER_URL}/signUp2/account/${userId}`;

export const GET_COUNTRIES_API = () =>
  `${SERVER_URL}/geographi/countries?limit=300`;

export const MERCHANT_URLS = () => `${SERVER_URL}/ops/users/new`;
export const MERCHANT_MENU_QUEUE_UNASSIGNED = () =>
  `${SERVER_URL}/menu-queue/unassigned`;
export const MERCHANT_ACTIVATE = (id) =>
  `${SERVER_URL}/ops/users/${id}/activate`;
export const MERCHANT_VERIFY = (id) => `${SERVER_URL}/ops/users/${id}/verify`;
export const MERCHANT_DEPLOY_OB_AUTOMATION = () =>
  `${SERVER_URL}/ops/users/bot-facebook-deploy`;
export const ACTIVE_MERCHANTS = () => `${SERVER_URL}/ops/locations/active`;
export const ACTIVE_LOCATION = (id) =>
  `${SERVER_URL}/ops/locations/active/${id}`;
export const ACTIVE_MERCHANT_BY_ID = (id) =>
  `${SERVER_URL}/ops/users/active/${id}`;
export const MERCHANT_URLS_ID = (id) => `${SERVER_URL}/locations/${id}`;
export const MERCHANT_CHANGE_USER = (id) => `${SERVER_URL}/user-auth/${id}`;
export const MERCHANT_PUT = (id) => `${SERVER_URL}/ops/users/${id}`;
export const LOCATION_ACTIVATE = (id) =>
  `${SERVER_URL}/ops/locations/${id}/activate`;
export const LOCATION_PUT = (id) => `${SERVER_URL}/ops/locations/${id}`;
export const API_UPDATE_LOCATION_SERVICE_FEATURES = (id) =>
  `${SERVER_URL}/ops/locations/feature-management/${id}`;
export const API_UPDATE_LOCATION_SALES_PACKAGE = (id) =>
  `${SERVER_URL}/ops/locations/sales-package/${id}`;
export const API_UPDATE_LOCATION_GMB_REVIEW_LINK = (id) =>
  `${SERVER_URL}/ops/locations/gmb-review-link/${id}`;

// ADMIN SUDO USERS

export const GET_SUDO_USERS_API = () => `${SERVER_URL}/ops/sudo-users`;
export const SUDO_USER_API = (id) => `${SERVER_URL}/ops/sudo-users/${id}`;
export const GET_ALL_SUDO_USER_FEATURE_FLAGS_API = () =>
  `${SERVER_URL}/app/sudo-users-feature-flags`;

// VIRTUAL NUMBER

export const LOCATION_VN_STATUS = (locationId) =>
  `${SERVER_URL}/virtual-numbers/${locationId}/status`;
export const API_CREATE_VN = (locationId) =>
  `${SERVER_URL}/virtual-numbers/${locationId}`;
export const API_UPDATE_VN = (locationId) =>
  `${SERVER_URL}/virtual-numbers/${locationId}`;
export const API_CREATE_TWILIO = (locationId) =>
  `${SERVER_URL}/virtual-numbers/${locationId}/create-twilio`;
export const API_ACTIVATE_VN = (locationId) =>
  `${SERVER_URL}/virtual-numbers/${locationId}/activate`;
export const API_DISABLE_VN = (locationId) =>
  `${SERVER_URL}/virtual-numbers/${locationId}/disable`;

// Admin panel API endpoints
export const GET_ADMIN_USERS = () => `${SERVER_URL}/ops/users`;
export const GET_ADMIN_MERCHANTS = () => `${SERVER_URL}/ops/merchants`;
export const GET_ADMIN_LOCATIONS = (merchantId) =>
  `${SERVER_URL}/ops/locations/${merchantId}`;
export const RESET_PASSWORD_ADMIN_API = (_id) =>
  `${SERVER_URL}/users/reset/${_id}`;
export const TEST_AUTOMATION_JOB_ID = (id) =>
  `${SERVER_URL}/ops/locations/${id}/set-test-job-id`;
export const TEST_AUTOMATION_RESULT = (id) =>
  `${SERVER_TEST_AUTO_URL}/api/result?result_id=${id}&extra=true`;
export const TEST_AUTOMATION = () => `${SERVER_TEST_AUTO_URL}/api/test`;

export const GET_ORDERS_RTB_V2 = () =>
  `${RDB_SERVICE_V2_URL}/api/delivery-orders/rdb`;

export const GET_ORDER_RTB_V2 = (id) =>
  `${RDB_SERVICE_V2_URL}/api/delivery-orders/rdb/${id}`;

export const POST_ORDER_RTB_V2_ACTION = (id) =>
  `${RDB_SERVICE_V2_URL}/api/delivery-orders/${id}/report-actions`;

export const REMOVE_ORDER_RTB_V2 = (id) =>
  `${RDB_SERVICE_V2_URL}/api/delivery-orders/${id}/remove`;

// FIND DELIVERY

export const FIND_DELIVERY = (id) =>
  `${RDB_SERVICE_V2_URL}/api/delivery-orders/find/${id}`;

// Authentication API endpoints
export const LOGIN_USER = () => `${SERVER_AUTH_URL}/login`;
export const UPDATE_TOKENS = () => `${SERVER_AUTH_URL}/refresh`;
export const DELETE_REFRESH_TOKEN = (userId) =>
  `${SERVER_AUTH_URL}/refresh/${userId}`;
export const SEND_MAIL = (email) =>
  `${SERVER_AUTH_URL}/reset_password/${email}`;
export const UPDATE_PASSWORD = (token) =>
  `${SERVER_AUTH_URL}/update_password/${token}`;
export const UPDATE_MEMBER_PASSWORD = (token) =>
  `${SERVER_AUTH_URL}/update_member_password/${token}`;
export const SAVE_USER_EMAIL = () => `${SERVER_URL}/registration`;
export const SIGNUP_USER = (email) => `${SERVER_URL}/registration/${email}`;
export const SELF_SIGNUP_USER = (email) =>
  `${SERVER_URL}/signUp2/registration/${email}`;
export const RETURN_TO_DASHBOARD = () =>
  `${SERVER_AUTH_URL}/return_to_old_dashboard`;

/* ORDERS */
export const API_ORDERS = (queryObj) =>
  `${SERVER_URL}/orders?${qs.stringify(queryObj)}`;
export const API_ORDER = (id) => `${SERVER_URL}/orders/${id}`;
export const API_DISPATCH_INFO = (id) =>
  `https://t.sauce.rest/api/tracking?order_id=${id}`;
export const API_ACTIVE_ORDERS = () => `${SERVER_URL}/orders/tab/active`;
export const API_TEST_ORDER = () => `${SERVER_URL}/orders/test`;
export const API_ORDER_INFO = (id) => `${SERVER_URL}/orders/info/${id}`;
export const API_ORDER_REFUND = (invoiceId) =>
  `${PAYMENT_ADJUSTMENTS_SERVICE_URL}/api/payment-adjustments/v1/orders/${invoiceId}/refunds/restaurant/process`;
export const API_GET_ORDER_REFUND_DATA = (invoiceId) =>
  `${PAYMENT_ADJUSTMENTS_SERVICE_URL}/api/payment-adjustments/v1/orders/${invoiceId}/refunds/restaurant/get-available-items`;
export const API_CALCULATE_ORDER_ADJUST = (invoiceId) =>
  `${PAYMENT_ADJUSTMENTS_SERVICE_URL}/api/payment-adjustments/v1/orders/${invoiceId}/price-adjustments/calculate`;
export const API_CREATE_ORDER_ADJUST = (invoiceId) =>
  `${PAYMENT_ADJUSTMENTS_SERVICE_URL}/api/payment-adjustments/v1/orders/${invoiceId}/price-adjustments/create`;
export const API_GET_DELIVERY_STATUS = (deliveryId) =>
  `${SERVER_URL}/order/${deliveryId}/delivery-status`;
export const API_GET_DELIVERY_ORDER_TRACKING = (deliveryId, locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/delivery/orders/${deliveryId}/tracking?locationId=${locationId}`;
export const API_RATE_DRIVER = () =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/rate-driver`;
export const API_GET_DRIVER_RATING = (deliveryId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/rate-driver/${deliveryId}`;
export const API_UPDATE_DRIVER_RATING = (deliveryId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/rate-driver/${deliveryId}`;
export const API_DELETE_DRIVER_RATING = (deliveryId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/rate-driver/${deliveryId}`;

export const API_CANCEL_ORDER_DELIVERY = (deliveryId) =>
  `${SERVER_URL}/order/${deliveryId}/cancel-delivery`;

// ORDERS V2

export const API_ORDERS_V2 = (locationId) =>
  `${ORDER_MANAGEMENT_SERVICE_URL}/api/order-management/v1/locations/${locationId}/orders/history`;
export const API_ORDER_V2 = (id) =>
  `${ORDER_MANAGEMENT_SERVICE_URL}/api/order-management/v1/orders/${id}`;
export const API_UPDATE_ORDER_STATUS_V2 = (id) =>
  `${ORDER_MANAGEMENT_SERVICE_URL}/api/order-management/v1/orders/${id}/update-status`;
export const API_CONVERT_ORDER_TO_LOCATION_DELIVERY = (id) =>
  `${ORDER_MANAGEMENT_SERVICE_URL}/api/order-management/v1/orders/convert/${id}/location-delivery`;
export const API_ACTIVE_ORDERS_V2 = (locationId) =>
  `${ORDER_MANAGEMENT_SERVICE_URL}/api/order-management/v1/locations/${locationId}/orders/active`;
export const API_ORDER_REFUND_V2 = (invoiceId) =>
  `${ORDER_MANAGEMENT_SERVICE_URL}/api/order-management/v1/orders/${invoiceId}/refunds/restaurant/process`;
export const API_GET_ORDER_REFUND_DATA_V2 = (invoiceId) =>
  `${ORDER_MANAGEMENT_SERVICE_URL}/api/order-management/v1/orders/${invoiceId}/refunds/restaurant/get-available-items`;
export const API_CALCULATE_ORDER_ADJUST_V2 = (invoiceId) =>
  `${ORDER_MANAGEMENT_SERVICE_URL}/api/order-management/v1/orders/${invoiceId}/price-adjustments/calculate`;
export const API_CREATE_ORDER_ADJUST_V2 = (invoiceId) =>
  `${ORDER_MANAGEMENT_SERVICE_URL}/api/order-management/v1/orders/${invoiceId}/price-adjustments/create`;

// BOOK A DRIVER

export const API_BAD_ORDER = () => `${SERVER_URL}/book-a-driver`;
export const API_BAD_ORDER_ACTIVE = (config) =>
  `${SERVER_URL_BOOK_A_DRIVER}/api/v1/orders/active?page=${config.page}&perPage=50&sortField=${config.sortField}&sortDir=${config.sortDir}&from=${config.from}&to=${config.to}`;
export const API_BAD_ORDER_HISTORY = (config) =>
  `${SERVER_URL_BOOK_A_DRIVER}/api/v1/orders/inactive?page=${config.page}&perPage=${config.perPage}&sortField=${config.sortField}&sortDir=${config.sortDir}`;
export const API_BAD_ORDER_DELIVERED = (config) =>
  `${SERVER_URL_BOOK_A_DRIVER}/api/v1/orders/by-status?status=${config.status}&status=scheduled&status=assigned&page=${config.page}&perPage=${config.perPage}&sortField=${config.sortField}&sortDir=${config.sortDir}&from=${config.from}&to=${config.to}`;
export const API_BAD_ORDER_DETAILS = (id) =>
  `${SERVER_URL_BOOK_A_DRIVER}/api/v1/orders/${id}`;
export const API_BAD_ADDRESSES = (phone) =>
  `${SERVER_URL_BOOK_A_DRIVER}/api/v1/orders/by-phone?phone=${phone}`;
export const API_BAD_DETAILS_NOTES = (id) =>
  `${SERVER_URL_BOOK_A_DRIVER}/api/v1/orders/${id}/notes/update`;
export const API_BAD_LARGE_ORDER_STATUS = (id) =>
  `${SERVER_URL_BOOK_A_DRIVER}/api/v1/orders/${id}/status/update`;
export const API_BAD_CHECK_ADDRESS = (isV2) =>
  isV2
    ? `${SERVER_URL_BOOK_A_DRIVER}/api/v2/quotes/create`
    : `${SERVER_URL_BOOK_A_DRIVER}/api/v1/quotes/create`;
// Analytics

export const API_GET_TOTAL_CUSTOMERS = (startDate, endDate) =>
  `${SERVER_URL}/analytics/totalCustomers${
    startDate && endDate ? `?startDate=${startDate}&endDate=${endDate}` : ''
  }`;
export const API_GET_TOTAL_SALES = (startDate, endDate) =>
  `${SERVER_URL}/analytics/totalSales${
    startDate && endDate ? `?startDate=${startDate}&endDate=${endDate}` : ''
  }`;
export const API_GET_SALES_PER_HOUR = (timezone, startDate, endDate) =>
  `${SERVER_URL}/analytics/salesByHours${
    startDate && endDate ? `?startDate=${startDate}&endDate=${endDate}` : ''
  }`;
export const API_GET_SALES_PER_ITEM = (startDate, endDate) =>
  `${SERVER_URL}/analytics/salesByItems${
    startDate && endDate ? `?startDate=${startDate}&endDate=${endDate}` : ''
  }`;

export const API_ANALYTICS_V3 = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v3/analytics-v3/${locationId}`;

export const API_ANALYTICS_V3_SALES_PER_ITEM = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v3/analytics-v3/${locationId}/sales-per-item`;

export const API_ANALYTICS_V3_CHANNELS = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v3/analytics-v3/${locationId}/channels`;

// MenuQueue

export const API_DELETE_MENU_QUEUE = (id) =>
  `${SERVER_URL}/menu-queue?id=${id}`;
export const API_CRUD_MENU_QUEUE = () => `${SERVER_URL}/menu-queue`;

// Reports
export const API_GENERATE_REPORT_SALES_SUMMARY = `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/sales-report/create`;
export const API_EXPORT_REPORT_SALES_SUMMARY = (reportId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/sales-reports/${reportId}/export/xlsx`;
export const API_BULK_EXPORT_SALES_SUMMARY = `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/sales-report/bulk-export`;

export const API_GENERATE_REPORTS_CUSTOMERS = `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/customer-report/create`;
export const API_EXPORT_REPORT_CUSTOMERS = (reportId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/customer-reports/${reportId}/export/xlsx`;

export const API_GENERATE_REPORT_PAYOUT_SUMMARY = `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/payouts-report/create`;
export const API_EXPORT_REPORT_PAYOUT_SUMMARY = (reportId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/payouts-reports/${reportId}/export/xlsx`;

export const API_GENERATE_REPORT_BOOK_A_DRIVER = `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/book-a-driver-report/create`;
export const API_GET_REPORTS_ORDERS_BOOK_A_DRIVER = (reportId, skip) =>
  `${REPORTS_SERVICE_URL}/odata/bookadriver-orders/${reportId}?$top=7&skip=${skip}&count=true`;
export const API_EXPORT_REPORT_BOOK_A_DRIVER = (reportId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/book-a-driver-reports/${reportId}/export/xlsx`;

export const API_GENERATE_REPORT_BYOC = `${REPORTS_SERVICE_URL}/byoc-reports/create`;
export const API_GET_REPORTS_ORDERS_BYOC = (reportId, skip) =>
  `${REPORTS_SERVICE_URL}/odata/byoc-orders/${reportId}?$top=7&skip=${skip}&count=true`;
export const API_EXPORT_REPORT_BYOC = (reportId) =>
  `${REPORTS_SERVICE_URL}/byoc-reports/${reportId}/export/xlsx`;

// Self Delivery Summary report endpoints
export const API_GENERATE_REPORT_SELF_DELIVERY_SUMMARY = `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/self-delivery-summary-report/create`;
export const API_EXPORT_REPORT_SELF_DELIVERY_SUMMARY = `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/self-delivery-summary-report/export/xlsx`;
export const API_GENERATE_REPORT_SELF_DELIVERY_INVOICES = `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/self-delivery-invoices-report/create`;
export const API_EXPORT_SELF_DELIVERY_INVOICE_ORDERS_CSV = `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/self-delivery-invoices-report/orders-csv`;
export const API_GET_SELF_DELIVERY_INVOICE_LINK = `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/self-delivery-invoices-report/invoice-link`;

export const API_GENERATE_REPORT_REFUNDS_SUMMARY = `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/refunds-report/create`;
export const API_GENERATE_REPORT_FEEDBACK_SUMMARY = `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/feedback-report/create`;
export const API_GENERATE_REPORT_BAD_SUMMARY = `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/book-a-driver-report/create`;
export const API_GET_REPORTS_CONTENT_REFUNDS_SUMMARY = (reportId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/refunds-report/${reportId}/refunds/query/dynamic-linq?orderBy=orderDate&take=1000`;
export const API_GET_REPORTS_CONTENT_FEEDBACK_SUMMARY = (reportId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/feedback-report/${reportId}/reviews/query/dynamic-linq?take=1000`;
export const API_EXPORT_REPORT_REFUNDS_SUMMARY = (reportId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/refunds-reports/${reportId}/export/xlsx`;
export const API_EXPORT_REPORT_FEEDBACK_SUMMARY = (reportId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/feedback-reports/${reportId}/export/xlsx`;
export const API_EXPORT_REPORT_BAD_SUMMARY = (reportId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/book-a-driver-reports/${reportId}/export/xlsx`;

export const API_GENERATE_REPORT_DISCOUNT_SUMMARY = `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/discounts-report/create`;
export const API_EXPORT_REPORT_DISCOUNT_SUMMARY = (reportId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/discounts-reports/${reportId}/export/xlsx`;

export const API_GENERATE_REPORT_CASHBACK_USAGE = `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/cashback-usage-report/create`;
export const API_EXPORT_REPORT_CASHBACK_USAGE = `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/cashback-usage-report/export/xlsx`;

export const API_GENERATE_REPORT_SALES_BREAKDOWN = `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/sales-breakdown-report/create`;
export const API_EXPORT_REPORT_SALES_BREAKDOWN = `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/sales-breakdown-report/export/xlsx`;

export const API_GET_SPECIAL_ORDERS_REPORT = () =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/orders-data/create`;

export const API_ADD_USER_TO_SPECIAL_ORDERS_REPORT = (merchantId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/reports/orders-data/merchants/${merchantId}/share`;

// UserManagement

export const API_GET_USERS = (merchant_name, page, sort, search, limit) =>
  `${SERVER_URL}/users?merchant=${merchant_name}&page=${page}&sort=${sort}&search=${search}&limit=${limit}`;
export const API_GET_COUNTER = (merchant_name) =>
  `${SERVER_URL}/users/stats?merchant=${merchant_name}`;
export const API_DELETE_USER = (id) => `${SERVER_URL}/users/${id}`;
export const API_CREATE_USER = () => `${SERVER_URL}/users`;
export const API_USER_UPDATE_PASSWORD = (id) =>
  `${SERVER_URL}/users/reset/${id}`;
export const API_SETUP_CALL = () => `${SERVER_URL}/main-page/setup-call`;

// AppSettings
export const API_GET_MENU_ITEMS = () => `${SERVER_URL}/app/service-items`;

// Discounts
export const API_CRUD_DISCOUNT = (discountId) =>
  `${SERVER_DISCOUNTS_URL}/api/discounts/${discountId}`;
export const API_CRUD_DISCOUNTS = (status) =>
  `${SERVER_DISCOUNTS_URL}/api/discounts?status=${status}`;
export const PUBLISH_DISCOUNTS = (menuConfigId) =>
  `${SERVER_MENU_SYNC_URL}/sync-bot/${menuConfigId}`;
export const API_CREATE_DISCOUNT = () =>
  `${SERVER_DISCOUNTS_URL}/api/discounts`;

// Discounts V2
export const API_GET_DISCOUNTS_V2 = (locationId) =>
  `${SERVER_DISCOUNTS_V2_URL}/api/loyalty/v2/dashboard/locations/${locationId}/discounts/query`;
export const API_GET_DISCOUNT_BY_ID_V2 = (discountId) =>
  `${SERVER_DISCOUNTS_V2_URL}/api/loyalty/v2/dashboard/discounts/${discountId}`;
export const API_DELETE_DISCOUNT_V2 = (discountId) =>
  `${SERVER_DISCOUNTS_V2_URL}/api/loyalty/v2/dashboard/discounts/${discountId}/delete`;
export const API_ARCHIVE_DISCOUNT_V2 = (discountId) =>
  `${SERVER_DISCOUNTS_V2_URL}/api/loyalty/v2/dashboard/discounts/${discountId}/archive`;
export const API_UPDATE_DISCOUNT_V2 = (discountId) =>
  `${SERVER_DISCOUNTS_V2_URL}/api/loyalty/v2/dashboard/discounts/${discountId}/update`;
export const API_CREATE_DISCOUNT_V2 = () =>
  `${SERVER_DISCOUNTS_V2_URL}/api/loyalty/v2/dashboard/discounts/create`;

export const API_GET_BOGO_ITEMS = (catalogId) =>
  `${MENU_SERVICE_URL}/api/menus/v2/dashboard/discounts/bogo/items?catalogId=${catalogId}`;
export const API_GET_DISCOUNTS_FOR_ITEMS = (locationId) =>
  `${SERVER_DISCOUNTS_V2_URL}/api/loyalty/v2/dashboard/locations/${locationId}/discounts/item-level/query`;

// Uber Eats
export const GET_UBER_EATS_MERCHANT_STATUS = (merchantId) =>
  `${SERVER_UBEREATS_URL}/api/uber-eats-adapter/v1/merchants/${merchantId}`;
export const GET_UBER_EATS_STORES = (merchantId) =>
  `${SERVER_UBEREATS_URL}/api/uber-eats-adapter/v1/merchants/${merchantId}/stores`;
export const GET_UBER_EATS_STORE_MENUS = (storeId) =>
  `${SERVER_UBEREATS_URL}/api/uber-eats-adapter/v1/stores/${storeId}/menus`;
export const POST_UBER_EATS_ONBOARDING_PROCESS = () =>
  `${SERVER_UBEREATS_URL}/api/uber-eats-adapter/v1/onboarding`;

// BYOC Onboarding
export const GET_BYOC_ONBOARDING_DATA = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/self-delivery-onboarding/${locationId}`;
export const UPDATE_BYOC_ONBOARDING_STEP = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/self-delivery-onboarding/${locationId}`;
export const SAVE_BYOC_SIGNATURE = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/self-delivery-onboarding/${locationId}/signup/signature`;
export const SAVE_BYOC_ADJUSTMENT_PRICE_RULES = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/self-delivery-onboarding/${locationId}/menu-setup/adjustment-price-rules`;
export const UPDATE_BYOC_PLATFORMS = (locationId) =>
  `${SERVER_URL}/self-delivery-onboarding/${locationId}/order-source-integration/platforms`;
export const GET_BYOC_SELF_DELIVERY_LINK = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/self-delivery-onboarding/${locationId}/self-delivery-agreement-link`;

export const GET_ANALYTICS_INFO = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/analytics/home-page-summary/${locationId}`;

export const GET_DISCOUNT_STATISTICS = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/analytics/discount-statistics/${locationId}`;

export const GET_CUSTOMER_INSIGHTS = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/analytics/customer-insights/${locationId}`;

// Cashback
export const GET_CASHBACK_SUMMARY = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/cashback/summary/${locationId}`;
export const GET_CASHBACK_SETTINGS = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/loyalty/v2/dashboard/locations/${locationId}/credit-campaigns`;
export const CREATE_CASHBACK_SETTINGS = () =>
  `${MERCHANT_DASHBOARD_API_URL}/api/loyalty/v2/dashboard/credit-campaigns/create`;
export const UPDATE_CASHBACK_SETTINGS = (campaignId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/loyalty/v2/dashboard/credit-campaigns/${campaignId}/update`;

// Invite a Bite (BFF)
export const API_GET_INVITE_A_BITE_INFO = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/locations/${locationId}/invite-a-bite/info`;

// Hubspot
export const POST_HUBSPOT_COMMENT = () => `${SERVER_URL}/hubspot/send-comment`;
export const GET_HUBSPOT_INFO = () => `${SERVER_URL}/hubspot-info`;

// Aggregation Platform Settings (BFF)
export const API_GET_AGGREGATION_PLATFORM_SETTINGS = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/locations/${locationId}/aggregation-platform-settings`;

// Bank Account (BFF)
export const API_CREATE_BANK_ACCOUNT_UPDATE_LINK = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/locations/${locationId}/bank-account/update-link`;

// Platform Commissions (HubSpot service)
export const API_GET_PLATFORM_COMMISSIONS = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/locations/${locationId}/aggregation-platform-settings`;
export const API_UPDATE_PLATFORM_COMMISSIONS = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/locations/${locationId}/aggregation-platform-settings`;

// Feedback
export const API_FEEDBACK_STATS = (feedbackType, startDate, endDate) =>
  `${FEEDBACK_SURVEY_SERVICE_URL}/api/v1/survey/stats?type=${feedbackType}&from=${startDate}&to=${endDate}`;

// Customer Feedback page (BFF aggregator)
export const API_GET_SURVEY_SUMMARY = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/locations/${locationId}/surveys/summary`;
export const API_GET_SURVEYS = (locationId, {page, limit, status}) => {
  const params = new URLSearchParams();
  if (page != null) params.set('page', String(page));
  if (limit != null) params.set('limit', String(limit));
  if (status) params.set('status', status);
  const search = params.toString();
  return `${MERCHANT_DASHBOARD_API_URL}/api/v1/locations/${locationId}/surveys${
    search ? `?${search}` : ''
  }`;
};
export const API_GET_SURVEY_CONTEXT = (locationId, reviewId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/locations/${locationId}/surveys/${reviewId}/context`;
export const API_SET_SURVEY_CONTACT_STATUS = (locationId, reviewId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/locations/${locationId}/surveys/${reviewId}/contact-status`;
export const API_SEND_SURVEY_REPLY = (locationId, reviewId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/locations/${locationId}/surveys/${reviewId}/reply`;
export const API_GET_SURVEY_REPLY_DISCOUNT = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/locations/${locationId}/surveys/reply-discount`;

export const API_BAD_DELIVERY_PRE_CHECK = () =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/book-a-driver/delivery/pre-check`;
export const API_BAD_CREATE_ORDER = () =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/book-a-driver/orders/create`;
export const API_BAD_INTRO = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/book-a-driver/${encodeURIComponent(
    locationId
  )}/intro`;
export const API_BAD_ORDERS_BY_CORE_ORDER = (
  coreOrderId,
  locationId,
  orderType
) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/book-a-driver/orders/by-core-order/${encodeURIComponent(
    coreOrderId
  )}?locationId=${encodeURIComponent(locationId)}${
    orderType ? `&orderType=${encodeURIComponent(orderType)}` : ''
  }`;

// Refunds Calculator
export const RC_GET_ORDER = (invoiceId) =>
  `${REFUND_CALCULATOR_URL}/${invoiceId}/calculator/info`;
export const RC_GENERATE_ORDER_REFUND = (
  id
) => `${REFUND_CALCULATOR_URL}/${id}/refunds/calculate
`;
export const RC_GENERATE_ORDER_REIMBURSEMENT = (
  id
) => `${REFUND_CALCULATOR_URL}/${id}/reimbursements/calculate
`;
export const RC_MAKE_ORDER_REFUND = (
  id
) => `${REFUND_CALCULATOR_URL}/${id}/refunds/process
`;
export const RC_MAKE_ORDER_REIMBURSEMENT = (
  id
) => `${REFUND_CALCULATOR_URL}/${id}/reimbursements/process
`;

// Email Marketing

export const POST_CONTACT_FORM_EMAIL_MARKETING = () =>
  `${SERVER_URL}/email-marketing/contact-us`;
export const GET_MARKETING_STATISTIC = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/email-marketing/events/summary/${locationId}`;
export const GET_EMAIL_MARKETING_SUMMARY = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/email-marketing/summary/${locationId}`;
export const GET_EMAIL_MARKETING_CAMPAIGNS = (locationId, params) => {
  const query = qs.stringify(params || {}, {
    skipNull: true,
    skipEmptyString: true
  });
  return `${MERCHANT_DASHBOARD_API_URL}/api/v1/email-marketing/campaigns/${locationId}${
    query ? `?${query}` : ''
  }`;
};
export const GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW = (
  locationId,
  campaignId,
  params
) => {
  const query = qs.stringify(params || {}, {
    skipNull: true,
    skipEmptyString: true
  });
  return `${MERCHANT_DASHBOARD_API_URL}/api/v1/email-marketing/campaigns/${locationId}/${campaignId}/preview${
    query ? `?${query}` : ''
  }`;
};
export const GET_EMAIL_MARKETING_CAMPAIGN_DETAIL = (
  locationId,
  campaignId,
  params
) => {
  const query = qs.stringify(params || {}, {
    skipNull: true,
    skipEmptyString: true
  });
  return `${MERCHANT_DASHBOARD_API_URL}/api/v1/email-marketing/campaigns/${locationId}/${campaignId}${
    query ? `?${query}` : ''
  }`;
};
export const GET_EMAIL_MARKETING_TRIAL_DATE = (locationId) =>
  `${SERVER_MARKETING_SERVICE_URL}/api/marketing/v1/email-marketing/pcs/locations/${locationId}/trial-info`;

// Flyers
export const SEND_FLYERS_REQUEST = () =>
  `${SERVER_MARKETING_SERVICE_URL}/api/flyers/v1/flyers-request/create`;

// Insights Growth

export const GET_INSIGHTS_GROWS_INFO = (locationId) =>
  `${INSIGHTS_SERVICE_URL}/api/v1/dashboard/locations/${locationId}/modules`;

export const POST_INSIGHTS_GROWTH_CONTACT_US = (id, feature) =>
  `${INSIGHTS_SERVICE_URL}/api/v1/dashboard/locations/${id}/modules/${feature}/enable`;

// Insights Performance

export const GET_INSIGHTS_PERFORMANCE_INFO = (locationId, from, to) =>
  `${INSIGHTS_SERVICE_URL}/api/v1/dashboard/locations/${locationId}/performance/metrics${
    from && to ? `?from=${from}&to=${to}` : ''
  }`;
export const GET_INSIGHTS_PERFORMANCE_SETTINGS_DATES = (locationId) =>
  `${INSIGHTS_SERVICE_URL}/api/v1/dashboard/locations/${locationId}/performance/metrics/metadata`;

export const GET_INSIGHTS_PERFORMANCE_SETTINGS_INFO = (locationId) =>
  `${INSIGHTS_SERVICE_URL}/api/v1/dashboard/locations/${locationId}/performance/settings`;

export const POST_INSIGHTS_PERFORMANCE_SETTINGS_INFO = (locationId) =>
  `${INSIGHTS_SERVICE_URL}/api/v1/dashboard/locations/${locationId}/performance/settings`;

export const GET_LOCATIONS_WITH_INSIGHTS = (search) =>
  `${SERVER_URL}/location-management/insights${
    search ? `?search=${search}` : ''
  }`;
export const POST_INSIGHTS_GROWTH_MODULES = (id) =>
  `${INSIGHTS_SERVICE_URL}/api/v1/dashboard/locations/${id}/module/update`;

// Store Appearance

export const PUT_STORE_APPEARANCE = (locationId) =>
  `${CONFIGURATION_SERVICE_URL}/api/configuration/v1/dashboard/locations/${locationId}/storefront-settings`;

// Phone Ordering
/**
 * @param locationId
 */
export const API_TOGGLE_PHONE_ORDERING = (locationId) =>
  `${SERVER_URL}/virtual-numbers/sudo/phone-ordering/${locationId}/toggle`;

export const API_TOGGLE_ALL_LOCATIONS_PHONE_ORDERING = () =>
  `${SERVER_URL}/virtual-numbers/sudo/phone-ordering/toggle`;

export const API_GET_LOCATIONS_PHONE_ORDERING = () =>
  `${SERVER_URL}/virtual-numbers/sudo/phone-ordering`;

/**
 * @param locationId
 */
export const API_UPDATE_PHONE_ORDERING = (locationId) =>
  `${SERVER_URL}/virtual-numbers/sudo/phone-ordering/${locationId}`;

export const API_PHONE_ORDERING_SETTINGS = () =>
  `${SERVER_URL}/virtual-numbers/sudo/phone-ordering/settings`;

export const FIND_BYOC_VIRTUAL_NUMBERS_API = (params) => {
  const query = qs.stringify(params || {}, {
    skipNull: true,
    skipEmptyString: true
  });
  return `${SERVER_URL}/byoc-virtual-numbers${query ? `?${query}` : ''}`;
};

export const CREATE_BYOC_VIRTUAL_NUMBER_API = (locationId) =>
  `${SERVER_URL}/byoc-virtual-numbers/${locationId}`;

export const UPDATE_BYOC_VIRTUAL_NUMBER_API = (id) =>
  `${SERVER_URL}/byoc-virtual-numbers/${id}`;

export const DELETE_BYOC_VIRTUAL_NUMBER_API = (id) =>
  `${SERVER_URL}/byoc-virtual-numbers/${id}`;

export const GET_BYOC_LOCATION_OTTER_BRANDS_API = (locationId) =>
  `${SERVER_URL}/byoc-virtual-numbers/locations/${locationId}/otter-brands`;

export const API_GET_MARKETING_INTEGRATIONS_INFO = (locationId) =>
  `${CONFIGURATION_SERVICE_URL}/api/configuration/v1/analytics-integration/locations/${locationId}`;
export const API_ENABLE_MARKETING_INTEGRATION = (
  locationId,
  integration,
  query
) =>
  `${CONFIGURATION_SERVICE_URL}/api/configuration/v1/analytics-integration/locations/${locationId}/${integration}/enable?${query}`;
export const API_DISABLE_MARKETING_INTEGRATION = (locationId, integration) =>
  `${CONFIGURATION_SERVICE_URL}/api/configuration/v1/analytics-integration/locations/${locationId}/${integration}/disable`;

export const API_GET_MERCHANTS_FROM_CONFIGURATION_SERVICE = (search) =>
  `${CONFIGURATION_SERVICE_URL}/api/configuration/v1/dashboard/merchants/autocomplete?term=${search}&limit=20`;

// Stripe
export const API_CREATE_STRIPE_CHECKOUT_SESSION = (locationId) =>
  `${MERCHANT_DASHBOARD_API_URL}/api/v1/self-delivery-onboarding/${locationId}/create-stripe-checkout-session`;

// Self Delivery Onboarding - Payment Details
export const API_MARK_PAYMENT_DETAILS_AS_FINISHED = (locationId) =>
  `${SERVER_URL}/self-delivery-onboarding/${locationId}/payment-details/mark-as-finished`;

export const API_UPDATE_STRIPE_FLOW_COMPLETED = (locationId) =>
  `${SERVER_URL}/self-delivery-onboarding/${locationId}/payment-details/stripe-flow-completed`;
